import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '@app-core/services';

export const authGuard: CanActivateFn = (_: ActivatedRouteSnapshot, routerState: RouterStateSnapshot) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService
    .isAuthenticated()
    .then((isAuthenticated) => {
      if (!isAuthenticated) {
        localStorage.setItem('redirectUrl', routerState.url);
        void router.navigate(['/login']);

        return false;
      } else {
        return true;
      }
    })
    .catch(() => {
      return false;
    });
};
